export class RejectMigrationRequest {
  reason: string;

  constructor(reason: string) {
    this.reason = reason;
  }
}

export class RemigrateMigrationRequest {
  reason: string;
  migration_id: number;
  protocols_ids: number[];
  sites_ids: Record<string, string[]>;

  constructor(
    reason: string,
    migration_id: number,
    protocols_ids: number[],
    sites_ids: Record<string, string[]> = {},
  ) {
    this.reason = reason;
    this.migration_id = migration_id;
    this.protocols_ids = protocols_ids;
    this.sites_ids = sites_ids;
  }
}

export class MigrationRemigrateResponse{
  reason:string;
  constructor(reason: string) {
    this.reason = reason;
  }
}
export class OverallMetrics {
  totalRecords: number = 0;
  succeeded: number = 0;
  failed: number = 0;
  constructor(
    totalRecords: number = 0,
    succeeded: number = 0,
    failed: number = 0
  ) {
    this.totalRecords = totalRecords;
    this.succeeded = succeeded;
    this.failed = failed;
  }
}
export class MigrationStatusColorMap {
  statusColor: string = "";
  statusIcon: string = "";
  color: string = "";
  constructor(
    statusColor: string = "",
    statusIcon: string = "",
    color: string = ""
  ) {
    this.statusColor = statusColor;
    this.statusIcon = statusIcon;
    this.color = color;
  }
}
